import {StockSearchPillCollectionBase} from "@/classes/stock/StockSearchPillCollectionBase";

export default class SkuHistorySearchPillCollection extends StockSearchPillCollectionBase {
    constructor() {
        super();

        this.jobNumber = {
            enabled: true,
            history: []
        };

        this.dateFrom = {
            enabled: true,
            history: []
        };

        this.dateTo = {
            enabled: true,
            history: []
        };

    }

}
